/**
 * @module accessDeviceHelper
 * @description Helper functions for access devices
 *
 * The following functions are based on the 'accessDeviceManufacturers' environment variable.
 * The variable should be in the following format: Manufacturer/ModelA-NumberOfAccessSteps,ModelB-NumberOfAccessSteps;Manufacturer2/ModelC-NumberOfAccessSteps,ModelD-NumberOfAccessSteps
 * Example file:
 * accessDeviceManufacturers = 'Igloo/Keybox3-3;ButterflyMx/7" Surface intercom-2,7" Recessed intercom-2;Latch/R-2'
 */
function checkManufacturersEnvVar() {
    if (!process.env.PEEK_APP_ACCESS_DEVICE_MANUFACTURERS) {
        console.error("Missing accessDeviceManufacturers environment variable");
        return false;
    }
    return true;
}
/**
 * Returns the list of access device manufacturers
 * @returns {Array} - List of access device manufacturers in PeekInputSelect format
 */
export function getAccessDevicesManufacturers() {
    var _a;
    if (!checkManufacturersEnvVar())
        return [];
    return (((_a = process.env.PEEK_APP_ACCESS_DEVICE_MANUFACTURERS) === null || _a === void 0 ? void 0 : _a.split(";").filter(Boolean).map((manufacturerData) => {
        const manufacturerName = manufacturerData.split("/")[0];
        return { id: manufacturerName, name: manufacturerName };
    })) || []);
}
/**
 * Returns the list of access device models for a given manufacturer
 * @param manufacturer
 * @returns {Array} - List of access device models in PeekInputSelect format
 */
export function getModelsByManufacturer(manufacturer) {
    var _a;
    if (!checkManufacturersEnvVar())
        return [];
    const manufacturerData = (_a = process.env.PEEK_APP_ACCESS_DEVICE_MANUFACTURERS) === null || _a === void 0 ? void 0 : _a.split(";").filter(Boolean).find((manufacturerData) => manufacturerData.split("/")[0] === manufacturer);
    if (!manufacturerData)
        return [];
    return (manufacturerData
        .split("/")[1]
        .split(",")
        .filter(Boolean)
        .map((modelData) => {
        const modelName = modelData.split("-")[0];
        return { id: modelName, name: modelName };
    }) || []);
}
/**
 * Returns the number of access steps for a given manufacturer and model
 * @param manufacturer
 * @param model
 * @returns {number} - Number of access steps
 */
export function getAccessStepsByModel(manufacturer, model) {
    var _a;
    if (!checkManufacturersEnvVar())
        return 0;
    const manufacturerData = (_a = process.env.PEEK_APP_ACCESS_DEVICE_MANUFACTURERS) === null || _a === void 0 ? void 0 : _a.split(";").filter(Boolean).find((manufacturerData) => manufacturerData.split("/")[0] === manufacturer);
    if (!manufacturerData)
        return 0;
    const modelData = manufacturerData
        .split("/")[1]
        .split(",")
        .filter(Boolean)
        .find((modelData) => modelData.split("-")[0] === model);
    if (!modelData)
        return 0;
    return parseInt(modelData.split("-")[1]) || 0;
}
